import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';
import { storage } from '@/utils';
import type { User } from '@/types';

export const Dashboard = () => {
  const navigate = useNavigate();
  const user = storage.get<User>('user');
  
  const handleLogout = () => {
    storage.remove('token');
    storage.remove('refreshToken');
    storage.remove('user');
    navigate('/login');
  };
  
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">控制台</h1>
          <Button onClick={handleLogout} className="btn-secondary">
            退出登录
          </Button>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          <Card>
            <div className="p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0 bg-primary-100 rounded-lg p-3">
                  <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <div className="ml-5 w-0 flex-1">
                  <dl>
                    <dt className="text-sm font-medium text-gray-500 truncate">用户信息</dt>
                    <dd className="text-lg font-medium text-gray-900">{user?.name || '未知用户'}</dd>
                  </dl>
                </div>
              </div>
            </div>
          </Card>
          
          <Card>
            <div className="p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0 bg-green-100 rounded-lg p-3">
                  <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div className="ml-5 w-0 flex-1">
                  <dl>
                    <dt className="text-sm font-medium text-gray-500 truncate">系统状态</dt>
                    <dd className="text-lg font-medium text-gray-900">运行正常</dd>
                  </dl>
                </div>
              </div>
            </div>
          </Card>
          
          <Card>
            <div className="p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0 bg-yellow-100 rounded-lg p-3">
                  <svg className="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div className="ml-5 w-0 flex-1">
                  <dl>
                    <dt className="text-sm font-medium text-gray-500 truncate">最后登录</dt>
                    <dd className="text-lg font-medium text-gray-900">刚刚</dd>
                  </dl>
                </div>
              </div>
            </div>
          </Card>
        </div>
        
        <div className="mt-8">
          <Card>
            <div className="px-4 py-5 sm:p-6">
              <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
                欢迎使用企业级前端框架
              </h3>
              <div className="mt-2 max-w-xl text-sm text-gray-500">
                <p>
                  这是一个基于 React + TypeScript + Tailwind CSS 的企业级前端框架，
                  提供了完整的开发基础设施，包括路由管理、状态管理、API 请求、
                  错误处理等功能，帮助您快速构建现代化 Web 应用。
                </p>
              </div>
              <div className="mt-5">
                <Button asChild className="btn-primary">
                  <a href="https://github.com" target="_blank" rel="noopener noreferrer">
                    查看文档
                  </a>
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};